import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap/modal';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ImageCropperModule } from 'ngx-image-cropper';

import { CoreServicesModule } from '@pm-ui/core-services';
import { BlurOnEnterDirective } from './directives';
import { ConfirmAlertComponent } from './components/confirm-alert/confirm-alert.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ConfirmAlertDuplicateSOComponent } from './components/confirm-alert/confirm-alert-duplicate-so/confirm-alert-duplicate-so.component';
import { AiChatWidgetComponent } from './components/ai-chat-widget/ai-chat-widget.component';
import { AiChatbotComponent } from './components/ai-chatbot/ai-chatbot.component';
import { Nl2brPipe } from './components/ai-chatbot/nl2br.pipe';

@NgModule({
  declarations: [
    BlurOnEnterDirective,
    ConfirmAlertComponent,
    FileUploadComponent,
    ConfirmAlertDuplicateSOComponent,
    AiChatWidgetComponent,
    AiChatbotComponent,
    Nl2brPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatIconModule,
    MatAutocompleteModule,
    GooglePlaceModule,
    ImageCropperModule,
    CoreServicesModule,
  ],
  exports: [
    BlurOnEnterDirective,
    ConfirmAlertComponent,
    FileUploadComponent,
    AiChatWidgetComponent,
    AiChatbotComponent,
    Nl2brPipe,
  ],
})
export class pmComponentsModule { }
